import { useFormContext } from 'react-hook-form';

// Mallens type avgör vilken körning som använder den, och därmed vilka fält som har någon effekt.
//
// Autogiro- och swishmallar plockar sina medlemmar med varsin egen urvalsfråga. De läser
// föreningar, tidning, medlemsstatus och profiler, men varken datumen eller värvad. Förfallodatumet
// kommer från körningen i stället för från mallen.
//
// Skillnaden mellan dem är leveransen: en autogiromall skickar en avi, så blankett, logotyp och
// adress betyder något där. En swishdragning skickar ingen avi alls.
export const useInvoiceTemplateType = () => {
  const { watch } = useFormContext();

  const type = (watch('type') as string) || '';

  const isSwish = type === 'swish';
  const isAutogiro = type === 'autogiro';

  return { type, isSwish, isAutogiro, usesRecurringSelection: isSwish || isAutogiro };
};
